<template>
  <AuthLayout>
    <template #form>
      <router-link to="/welcome" class="auth-brand">
        <img src="/assets/logo.png" alt="Logo Saineo" class="auth-brand__mark" />
        <span class="auth-brand__name">saineo</span>
      </router-link>

      <h1 class="auth-title">Créons ton profil santé</h1>
      <p class="auth-subtitle">
        Quelques questions pour personnaliser tes menus selon tes objectifs et besoins.
      </p>

      <div class="register-progress">
        <v-progress-linear
          color="#111111"
          height="8"
          :model-value="currentQuestionIndex + 1"
          :max="totalVisibleQuestions"
          rounded
        ></v-progress-linear>
        <span class="register-progress__count">
          {{ currentQuestionIndex + 1 }} / {{ totalVisibleQuestions }}
        </span>
      </div>

      <div class="register-question">
        <Register_question_block
          v-if="currentQuestion"
          :question="currentQuestion.question"
          :options="currentQuestion.options"
          :multipleChoice="currentQuestion.multipleChoice"
          :type="currentQuestion.type"
          :langKey="currentQuestion.key"
          :value="responses[currentQuestion.key]"
          :allResponses="responses"
          @nextStep="nextStep"
          @previousStep="previousStep"
          @update="updateAnswer"
        />
      </div>
    </template>
  </AuthLayout>
</template>
<script>
import { formStore } from '@/store/register_store';
import questions from '@/data/register_questions.json';
import Register_question_block from '../Utils/Account/register_question_block.vue';
import AuthLayout from '@/components/PublicPages/AuthLayout.vue';
export default {
  emits: ['nextStep', 'previousStep', 'update'],
  name: 'RegisterQuestions',
  components: { Register_question_block, AuthLayout },
  data() {
    return {
      step: 0,
      questions,
      responses: formStore.responses,
      visibleQuestions: [],
    };
  },
  watch: {
    step(newStep) {
      this.cleanMultipleChoiceResponses(newStep);
    },
    responses: {
      handler() {
        this.updateVisibleQuestions();
      },
      deep: true,
    },
  },
  computed: {
    currentQuestion() {
      return this.visibleQuestions[this.step] || null;
    },
    currentQuestionIndex() {
      return this.step;
    },
    totalVisibleQuestions() {
      return this.visibleQuestions.length;
    },
  },
  methods: {
    shouldShowQuestion(question) {
      if (!question.conditional || !question.showIf) {
        return true;
      }
      const { key, values } = question.showIf;
      const responseValue = this.responses[key];
      if (Array.isArray(values)) {
        return values.includes(responseValue);
      }
      return responseValue === values;
    },
    updateVisibleQuestions() {
      this.visibleQuestions = this.questions.filter(q => this.shouldShowQuestion(q));
    },
    cleanMultipleChoiceResponses(currentStep) {
      const currentQ = this.visibleQuestions[currentStep];
      if (currentQ?.multipleChoice) {
        if (!this.responses[currentQ.key] || !Array.isArray(this.responses[currentQ.key])) {
          this.responses[currentQ.key] = [];
        }
      }
    },
    updateAnswer({ key, value }) {
      this.responses[key] = value;
      
      // Enregistrer le originalWeight quand actualWeight est défini
      if (key === 'actualWeight' && value && !this.responses.originalWeight) {
        this.responses.originalWeight = value;
      }
    },
    nextStep() {
      if (this.step < this.visibleQuestions.length - 1) {
        this.step++;
      } else {
        const allAnswered = this.visibleQuestions.every(q => {
          const response = this.responses[q.key];
          return response !== undefined && response !== null && response !== '';
        });
        
        if (allAnswered) {
          // S'assurer que originalWeight est bien défini avant de finaliser
          if (!this.responses.originalWeight && this.responses.actualWeight) {
            this.responses.originalWeight = this.responses.actualWeight;
          }
          
          this.$router.push('/final_register');
        } else {
          alert('Veuillez répondre à toutes les questions !');
        }
      }
    },
    previousStep() {
      if (this.step > 0) {
        this.step--;
      }
    },
  },
  mounted() {
    this.updateVisibleQuestions();
    this.visibleQuestions.forEach(q => {
      if (q.multipleChoice && !this.responses[q.key]) {
        this.responses[q.key] = [];
      }
    });
    
    // Si actualWeight existe déjà mais pas originalWeight, le définir
    if (this.responses.actualWeight && !this.responses.originalWeight) {
      this.responses.originalWeight = this.responses.actualWeight;
    }
  },
};
</script>
<style scoped>
  .auth-brand {
      display: inline-flex;
      align-items: center;
      gap: 12px;
      text-decoration: none;
      color: inherit;
      font-weight: 700;
      letter-spacing: -0.02em;
      margin-bottom: 16px;
  }

  .auth-brand__mark {
      width: 34px;
      height: 34px;
      object-fit: contain;
      display: block;
  }

  .auth-title {
      margin: 0;
      font-size: clamp(2rem, 4vw, 2.8rem);
      font-weight: 600;
      letter-spacing: -0.03em;
      color: #1A1615;
      line-height: 120%;
  }


  .auth-subtitle {
      margin: 6px 0 24px;
      color: #3c3f46;
      line-height: 1.6;
  }

  .register-progress {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 24px;
  }

  .register-progress__count {
      font-size: 0.95rem;
      color: #3c3f46;
      font-weight: 600;
      white-space: nowrap;
  }

  .register-question {
      width: 100%;
      display: flex;
  }

  :deep(.mainQuestionContainer) {
      background: #ffffff !important;
      border-radius: 24px;
      box-shadow: 0 18px 40px rgba(20, 28, 40, 0.12);
      padding: clamp(20px, 3vw, 32px);
      width: 100% !important;
      max-width: none !important;
      margin-inline: auto;
      align-items: center;
      text-align: center;
  }

  :deep(.w-full) {
      width: 100%;
  }

  :deep(.inputAnswer) {
      border-radius: 14px;
      border: 1px solid #d7dde5;
      padding: 12px 14px;
      font-size: 1rem;
      width: 100%;
      box-sizing: border-box;
  }

  :deep(.option) {
      border-radius: 18px;
      box-shadow: none;
      border: 1px solid #d7dde5;
      align-items: flex-start;
      text-align: left;
  }

  :deep(.option.bg-tertiary) {
      background: #f7f8fb;
  }

  :deep(.option.bg-tertiary.borderAccent) {
      border-color: #111111 !important;
  }

  :deep(.borderAccent) {
      border-color: #111111 !important;
  }

  :deep(.option:hover) {
      border-color: #111111 !important;
  }

  :deep(.nextButton) {
      border-radius: 999px;
      background: #111111 !important;
      color: #ffffff !important;
      padding: 12px 26px;
      box-shadow: none;
  }

  :deep(.previousButton) {
      border-radius: 999px;
      padding: 12px 26px;
      background: transparent !important;
      color: #1A1615 !important;
      border: 2px solid #1A1615 !important;
      box-shadow: none !important;
  }

</style>
